import { render, staticRenderFns } from "./SetupPasswordView.vue?vue&type=template&id=080e48b3&scoped=true&"
import script from "./SetupPasswordView.vue?vue&type=script&lang=js&"
export * from "./SetupPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./SetupPasswordView.vue?vue&type=style&index=0&id=080e48b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e48b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VCheckbox,VContainer,VExpandTransition,VFlex,VLayout,VTextField})
